module.exports = __webpack_public_path__ + "img/vi-en-logo.4ba520c1.png";